import sv from "./marketing";
import styled from '@emotion/styled'

export const ContentWrapper = styled(`div`)`
    display: flex;
    max-width: 1200px;
    align-self: center;
`;

export const Content = styled('div')`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
`;

export const Title = styled(`h1`)`
  ${sv.title};
  font-size: 30px;
  color: ${sv.colors.headline};
  text-align: start;
  margin-bottom: 40px;
`;

export const TopDescriptionItem = styled('div')`
  margin-bottom: 40px;
`;

export const Section = styled('div')`
  width: 100%;
  margin: 20px 0;
`;

export const SubSections = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: ${props => props.flexDirection ? props.flexDirection : "row"};
`;

export const SubSection = styled(`div`)`
  display: flex;
  flex-direction: column;
  flex-basis: 0;
  flex-grow: ${props => props.flexGrow ? props.flexGrow : 1};
  min-width: 180px;

  line-height: 1.3em;
  color: ${sv.colors.subHeadline};
  margin-bottom: 16px;
  padding: 16px;

  justify-content: ${props => props.justifyContent ? props.justifyContent : "start"};
  align-content: ${props => props.align ? props.align : "flex-start"};
  align-items: ${props => props.align ? props.align : "flex-start"};
  text-align: ${props => props.align ? props.align : "start"};

  p {
    margin: 6px;
  }

  em {
    font-style: italic;
  }
`;

export const SubSectionItem = styled('div')`
  margin-bottom: 16px;
`;

export const SubHeading = styled('h3')`
  ${sv.h3};
  color: ${sv.colors.subHeadline};
  margin-bottom: 16px;
`;

export const Heading = styled('h2')`
  ${sv.h2};
  color: ${sv.colors.headline};
  padding: 16px;
`;

export const VideoContainer = styled(SubSection)`
  position: relative;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0 0 6px rgba(0, 0, 0, .3);
  overflow: hidden;
  min-height: 400px;
  margin: 16px 16px 0 16px;

  &:before {
    padding-bottom: 56.25%;
    content: '';
    float: left;
  }

  &:after {
    display: table;
    content: '';
    clear: both;
  }
`;

export const VideoConstraint = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

export const ButtonContainer = styled('div')`
  ${props => props.topPadded ? 'padding-top: 15px' : ''};
`;

export const Icon = styled('img')`
  width: 100%;
  max-width: 400px;
  object-fit: contain;
`;

export const VideoPitch = styled(`div`)`
  line-height: 1.3em;
  color: ${sv.colors.headline};
  margin: -10px 0 20px 0;
  text-align: center;
  font-style: italic;
  font-weight: 600;
  font-size: 17px;
`;

export const VideoPitchIcon = styled(`img`)`
  height: 28px;
  width: 28px;
  margin-bottom: -6px;
`;